import { useMutation } from '@tanstack/react-query'

import { invitationsApi } from '@/api/invitationsApi'
import type { InviteInput } from '@/features/invitations/schemas/invitationSchemas'

/** No toast: the modal shows the one-time link instead, which is the point. */
export function useCreateInvitation() {
  return useMutation({
    mutationFn: ({ input, locationPublicId }: { input: InviteInput; locationPublicId: string }) =>
      invitationsApi.create(input, locationPublicId),
  })
}
